"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _GlobalNavigation = _interopRequireDefault(require("../Navigation/GlobalNavigation"));

var _GlobalNavigationV = _interopRequireDefault(require("../Navigation/GlobalNavigationV2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
const templateArea = "\n  '. main . '\n  '. . .';\n";
const templateAreaGlobalNav = "\n  'header header header'\n  '. main . '\n  '. . .';\n";
const templateRows = 'auto 10rem';
const templateRowsGlobalNav = '7rem auto 10rem';

const MainWrapper = _styledComponents.default.div.withConfig({
  displayName: "GalleryLayout__MainWrapper",
  componentId: "design-system__sc-1jr173g-0"
})(["display:grid;grid-template-columns:56px auto 56px;grid-template-rows:", ";grid-template-areas:", ";& > header{grid-area:header;border-bottom:1px solid ", ";}& > main{grid-area:main;display:grid;grid-template-columns:repeat(auto-fit,minmax(360px,1fr));column-gap:2rem;row-gap:2rem;}"], _ref => {
  let {
    hideGlobalNav
  } = _ref;
  return hideGlobalNav ? templateRows : templateRowsGlobalNav;
}, _ref2 => {
  let {
    hideGlobalNav
  } = _ref2;
  return hideGlobalNav ? templateArea : templateAreaGlobalNav;
}, _BaseTheme.default.colors.lightgray);

const GalleryLayout = _ref3 => {
  let {
    productTitle,
    productTitleLink,
    config,
    games,
    gameSlug,
    allPath,
    allPathOnClick,
    globalMenu,
    globalMenuAction,
    supportMenu,
    children,
    searchPath,
    searchPlaceholder,
    searchValue,
    logout,
    userImage,
    userEmail,
    hideGlobalNavigation
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(MainWrapper, {
    hideGlobalNav: hideGlobalNavigation
  }, config && !hideGlobalNavigation && /*#__PURE__*/_react.default.createElement(_GlobalNavigationV.default, {
    title: productTitle,
    titleLink: productTitleLink,
    config: config,
    games: games,
    gameSlug: gameSlug,
    allPath: allPath,
    allPathOnClick: allPathOnClick,
    logout: logout
  }), !config && !hideGlobalNavigation && /*#__PURE__*/_react.default.createElement(_GlobalNavigation.default, {
    title: productTitle,
    titleLink: productTitleLink,
    globalMenu: globalMenu,
    globalMenuAction: globalMenuAction,
    supportMenu: supportMenu,
    searchPath: searchPath,
    searchPlaceholder: searchPlaceholder,
    searchValue: searchValue,
    logout: logout,
    userImage: userImage,
    userEmail: userEmail
  }), /*#__PURE__*/_react.default.createElement("main", null, children), /*#__PURE__*/_react.default.createElement("link", {
    href: "https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
    rel: "stylesheet"
  }));
};

GalleryLayout.propTypes = {
  productTitle: _propTypes.default.string.isRequired,
  productTitleLink: _propTypes.default.string,
  hideGlobalNavigation: _propTypes.default.bool,
  config: _propTypes.default.shape({
    global: _propTypes.default.arrayOf(_propTypes.default.object),
    settings: _propTypes.default.arrayOf(_propTypes.default.object),
    user: _propTypes.default.shape({
      title: _propTypes.default.string,
      picture: _propTypes.default.string
    })
  }),
  games: _propTypes.default.arrayOf(_propTypes.default.object),
  gameSlug: _propTypes.default.string,
  allPath: _propTypes.default.oneOfType([_propTypes.default.any]),
  allPathOnClick: _propTypes.default.func,
  globalMenu: _propTypes.default.arrayOf(_propTypes.default.object),
  globalMenuAction: _propTypes.default.shape({
    url: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired
  }),
  supportMenu: _propTypes.default.arrayOf(_propTypes.default.object),
  children: _propTypes.default.node.isRequired,
  searchPath: _propTypes.default.string,
  searchValue: _propTypes.default.string,
  searchPlaceholder: _propTypes.default.string,
  userImage: _propTypes.default.string,
  userEmail: _propTypes.default.string,
  logout: _propTypes.default.func
};
GalleryLayout.defaultProps = {
  productTitleLink: undefined,
  hideGlobalNavigation: false,
  config: {
    global: [],
    settings: [],
    user: {}
  },
  games: [],
  gameSlug: 'allGames',
  globalMenu: [],
  allPath: '/',
  allPathOnClick: undefined,
  globalMenuAction: undefined,
  supportMenu: [],
  searchPath: undefined,
  searchValue: undefined,
  searchPlaceholder: undefined,
  logout: undefined,
  userImage: undefined,
  userEmail: undefined
};
var _default = GalleryLayout;
exports.default = _default;